import { render, staticRenderFns } from "./preferences-card.vue?vue&type=template&id=2a64e5ae&scoped=true"
import script from "./preferences-card.vue?vue&type=script&lang=ts"
export * from "./preferences-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64e5ae",
  null
  
)

export default component.exports